import React from 'react';

import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

// The selected-account trigger chip shared by both toolbar account filters (the Bank multi-select's
// first chip and the Credit Card single-select), so the two tabs render an identical value even
// though their selection behaviour differs. Ellipsises a long label and surfaces the full text on
// hover (DA-19483 — long provider labels like "Open Finance Sandbox - 4456" are otherwise clipped).
const SelectedAccountChip: React.FC<{ label: string }> = ({ label }) => (
  <Tooltip title={label} placement="bottom-start">
    <Chip label={label} size="small" sx={{ minWidth: 0, maxWidth: '100%' }} />
  </Tooltip>
);

export default SelectedAccountChip;
